import React from 'react'
import Header from './header'
import Menu from './nav'



export default class Header_Container extends React.Component{
	constructor(props) {
		super(props);
		this.state = {
			menu_hover: false,
		}
		this._handleClick = this._handleClick.bind(this)
	}

	_handleClick(){
		this.setState({
			menu_hover: !this.state.menu_hover, 
		})
	}
	


	render(){
			let divStyle = {}
				if( this.state.menu_hover) {
					divStyle = {
					 position: "fixed",
					 width: "80%",
					 height: "100%",
					 background:"#fff",
					 zIndex: "20",
					 left:"0"
					 
					}
				} else {
					divStyle = {
					  position: "fixed",
						width: "80%",
						 height: "100%",
						 background: "#fff",
						 zIndex: "20",
						 left:"-80%"
					}
			 }

			return(
			 <div> 
				<Header _handleClick = { this._handleClick }/>
				<Menu  divStyle = {divStyle }  _handleClick = { this._handleClick }/>
			 </div>
			 )
		}
}


// WEBPACK FOOTER //
// ./src/components/Header_Container.js